import React from 'react';
import classNames from 'classnames';
import Loader from '../loader';

function DialogButton({ onClick, disabled = false, isLoading = false, children, ...otherProps }) {
  const classes = classNames('ws-ui-dialog-btn', {
    'ws-ui-dialog-btn--loading': !disabled && isLoading,
  });

  const loaderComponent = isLoading ? (
    <div className="ws-ui-dialog-btn__loader-wrapper">
      <Loader />
    </div>
  ) : null;

  return (
    <button
      className={classes}
      disabled={disabled}
      // @ts-ignore TS(2322): Type '((...args: any[]) => any) | null' is not ass... Remove this comment to see the full error message
      onClick={!isLoading ? onClick : null}
      {...otherProps}
    >
      {children}
      {!disabled && loaderComponent}
    </button>
  );
}

export default DialogButton;
